// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__Q6jKg","title":"PrivacyPolicy_title__tMLgO","content":"PrivacyPolicy_content__cc8Um"};